<!--eslint-disable vue/no-v-text-v-html-on-component-->
<template>
  <iButton
    v-if="shouldRenderButton"
    :key="defaultTemplateName"
    :size="myButtonSize"
    :variant="getOptionValue(ButtonType)"
    :width="getOptionValue(LayoutWidth)"
    :height="getOptionValue(LayoutHeight)"
    :style-overrides="buttonStyleOverrides"
    :text-alignment="getOptionValue(TextAlignment)"
    :content-width="myContentWidth"
    :icon-left="displayLeftIcon ? getOptionValue(Icon) : ''"
    :icon-right="displayRightIcon ? getOptionValue(Icon) : ''"
    :icon-top="displayTopIcon ? getOptionValue(Icon) : ''"
    :icon-bottom="displayBottomIcon ? getOptionValue(Icon) : ''"
    :icon-left-size="displayLeftIcon ? (myIconSize ?? fontSizeNumberValue) : 'standard'"
    :icon-right-size="displayRightIcon ? (myIconSize ?? fontSizeNumberValue) : 'standard'"
    :icon-top-size="displayTopIcon ? (myIconSize ?? fontSizeNumberValue) : 'standard'"
    :icon-bottom-size="displayBottomIcon ? (myIconSize ?? fontSizeNumberValue) : 'standard'"
    :icon-color="fontColor"
    :href="myHref"
    @click="handleButtonClick"
  >
    <template #[defaultTemplateName]>
      <iRichText
        ref="richTextElement"
        :model-value="initialValue"
        prevent-new-line
        :preview="previewMode"
        :show-toolbar="false"
        :show-bubble-menu="true"
        :tools-to-disable="['text-align', 'link', 'bullet-list']"
        :style-overrides="{
          borderWidth: 'none',
          borderRadius: 'none',
          paddingLeft: 'none',
          paddingRight: 'none',
          paddingTop: 'none',
          paddingBottom: 'none',
        }"
        v-bind="textOnlyAttributes"
        @click="editMode && handleClick($event)"
        @blur="handleBlur"
        @keydown.enter="handleBlur"
        @update:model-value="handleTextOptionUpdate($event)"
      />
    </template>
  </iButton>
</template>

<script>
import {
  ButtonElementMixin,
} from "%/dynamic-components/render-engine/components/production/elements/button-element/button-element-mixin";
import PositioningOptions from "%/dynamic-components/render-engine/bundles/positioning-options";
import LayoutWidthHeightOptions from "%/dynamic-components/render-engine/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-components/render-engine/bundles/appearance-options";
import ButtonOptions from "%/dynamic-components/render-engine/bundles/button-options";
import SpacingOptions from "%/dynamic-components/render-engine/bundles/spacing-options";
import BasicTextOptions from "%/dynamic-components/render-engine/bundles/basic-text-options";
import TextOptions from "%/dynamic-components/render-engine/bundles/text-options";

export default {
  name: "StaticButtonElement",
  elementPanelSettings: {
    displayName: "Button",
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  mixins: [ButtonElementMixin],
  computed: {
    myHref() {
      return "";
    },
  },
  optionBundles: [
    PositioningOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    ButtonOptions,
    SpacingOptions,
    new BasicTextOptions({
      "default.font-color": {
        value: "light",
        source: "theme.font",
      },
    }),
    new TextOptions({
      "default.text-wrap": "nowrap",
    }),
  ],
};
</script>

<style lang="scss" scoped>
</style>
